// const { commentsData } = await import('./data');
const { commentsData } = require("./data");

const UPDATE_NEW_SEARCH_TEXT = "UPDATE-NEW-SEARCH-TEXT";
const ADD_MESSAGE = "ADD-MESSAGE";
const UPDATE_NEW_MESSAGE_TEXT = "UPDATE-NEW-MESSAGE-TEXT";

let initialState = {
  commentsData,
  newSearchText: "",
};

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MESSAGE:
      let newMessage = {
        id: 6,
        message: state.newMessageText,
        isItYou: true,
      };
      return {
        ...state,
        newMessageText: "",
        messagesData: [...state.messagesData, newMessage],
      };
    case UPDATE_NEW_SEARCH_TEXT:
      return {
        ...state,
        newSearchText: action.newText,
      };
    default:
      return state;
  }
};

export const addMessageActionCreator = () => ({ type: ADD_MESSAGE });

export const updateNewSearchTextActionCreator = (text) => ({
  type: UPDATE_NEW_SEARCH_TEXT,
  newText: text,
});

export default messagesReducer;
